import {Log} from '@aboutyou/mlm';
import {useValidateUserToken} from '@aboutyou/user';
import {useEffect} from 'react';
import {useLogoutHandler} from '../hooks/useLogoutHandler';

export const AuthenticationValidator = () => {
  const {data} = useValidateUserToken();
  const {logout} = useLogoutHandler();

  useEffect(() => {
    if (data?.isValid === false) {
      Log.error('@aboutyou/logic-components', 'SessionValidationErrors', {
        error_message:
          'AuthenticationValidator: User is logged in but the Auth Token is not valid',
      });

      logout('sessionValidator');
    }
  }, [data]);

  return null;
};
